import React, { useEffect, useState } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import {
  theme,
  Accordion,
  AccordionGroup,
  optionDataAccordionList,
  Text,
  typography,
} from "ui-components";
import { translate } from "../../../i18n";
import { testProps } from "../../../utils/testProps";
interface DatePickerDropdownNewFixedProps {
  minimumDate?: Date;
  maximumDate?: Date;
  formName?: string;
  onChange: Function | any;
  title?: string;
  date?: any;
}

export const DatePickerDropdownNewFixed = (props: DatePickerDropdownNewFixedProps) => {
  const {
    minimumDate = new Date(),
    maximumDate = new Date(),
    formName,
    onChange,
    title = "Choose a date for payment",
    date,
  } = props;
  const styles = getStyles();

  const onDatePick = (selectedDate: Date, selectedItem: string) => {
    onChange && onChange(selectedDate, selectedItem);
  };

  let [expandedId, setExpandedId] = useState();
  const defaultAccordionTitle = title;
  let [accordionTitle, setAccordionTitle] = useState(defaultAccordionTitle);

  const onAccordionPress = (newExpandedId: any) => {
    setExpandedId((currentExpandedId) =>
      currentExpandedId === newExpandedId ? undefined : newExpandedId
    );
  };

  const onOptionSelected = (newExpandedId: any) => {
    onAccordionPress(newExpandedId);
    setSelectedOptionAccordionId(newExpandedId);
  };

  let [selectedOptionAccordionId, setSelectedOptionAccordionId] = useState();
  let [selectedItem, setSelectedItem] = useState();
  let [dateOptionList, setDateOptionList] = useState<optionDataAccordionList[]>([]);

  const nth = function (d: number) {
    const dString = String(d);
    const last = +dString.slice(-2);
    if (last > 3 && last < 21) return "th";
    switch (last % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const getDates = () => {
    let dateList = [];
    dateList.push(firstOptionForDateOptionList);
    let d = minimumDate;
    while (d <= maximumDate) {
      let dateOptionObject: optionDataAccordionList = {
        key: "",
      };
      dateOptionObject.selectable = true;
      dateOptionObject.key = new Date(d).toISOString();
      dateOptionObject.title = `${new Date(d).getDate()}${nth(new Date(d).getDate())} ${translate(
        "autopay.summary.ofEveryMonth"
      )}`;
      dateOptionObject.date = new Date(d);
      dateList.push(dateOptionObject);
      d.setDate(d.getDate() + 1);
    }
    setDateOptionList(dateList);
  };

  useEffect(() => {
    getDates();
  }, []);
  return (
    <AccordionGroup expandedId={expandedId} onAccordionPress={onAccordionPress}>
      <Accordion
        title={accordionTitle}
        id={"accordion1"}
        expandedId={expandedId}
        leftIconName={"calendar"}
        selectedOptionAccordionId={selectedOptionAccordionId}
        titleStyle={{
          color: accordionTitle == defaultAccordionTitle ? theme.colors.text2 : theme.colors.text3,
        }}
        {...testProps("accordion-" + formName)}>
        <>
          {dateOptionList?.map((item, index) => (
            <View key={index}>
              <TouchableOpacity
                key={item?.key}
                style={{
                  padding: 12,
                  paddingHorizontal: 12,
                  backgroundColor: item.key == selectedItem?.key ? "#E6F0FA" : theme.colors.white,
                  borderBottomLeftRadius: index + 1 == dateOptionList?.length ? 10 : 0,
                  borderBottomRightRadius: index + 1 == dateOptionList?.length ? 10 : 0,
                }}
                disabled={!item?.selectable}
                onPress={() => {
                  onOptionSelected("accordion1");
                  setAccordionTitle(item.title);
                  setSelectedItem(item);
                  onDatePick(item.date, item.title);
                }}>
                <View style={{}}>
                  {item?.uiElement ? (
                    item?.uiElement
                  ) : (
                    <Text
                      style={[
                        styles.title,
                        {
                          color:
                            item.key == selectedItem?.key
                              ? theme.colors.secondary
                              : theme.colors.text3,
                        },
                      ]}>
                      {item?.title}
                    </Text>
                  )}
                </View>
              </TouchableOpacity>
              {index + 1 != dateOptionList?.length && <RenderSeparator />}
            </View>
          ))}
        </>
      </Accordion>
    </AccordionGroup>
  );
};

const getStyles = () => {
  return StyleSheet.create({
    modalContainer: {
      borderRadius: 10,
    },
    picker: {
      width: "100%",
      padding: 15,
    },
    textInput: {},
    title: {
      ...typography.title2,
      color: theme.colors.text3,
    },
  });
};

const firstOptionForDateOptionList = {
  key: "1",
  uiElement: (
    <View
      style={{
        flex: 1,
      }}>
      <Text style={[typography.body, { color: theme.colors.secondary, textAlign: "center" }]}>
        Your property accepts the following dates for on-time AutoPay.
      </Text>
    </View>
  ),
  selectable: false,
};

const RenderSeparator = () => {
  return (
    <View
      style={{
        borderColor: theme.colors.mediumGrey,
        borderTopWidth: 1,
      }}
    />
  );
};
